export default "__VITE_ASSET__DMWdXfrx__ 400w, __VITE_ASSET__CiIrmHYa__ 800w, __VITE_ASSET__DOqAOhWQ__ 1280w";